'use strict'

require './main'

if !window.Promise
  window.Promise = require 'promise-polyfill'

require 'whatwg-fetch'

PageApplication = require '../../modules/page/frontend/application'
HomeApplication = require '../../modules/home/frontend/application'

PageApplication.initialize()
HomeApplication.initialize()
